module.exports = __webpack_public_path__ + "img/empty_icon.823f5381.png";